module.exports = __webpack_public_path__ + "static/img/ttt.42d5615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ttt.png
// module id = /Y2W
// module chunks = 1